<template>
  <div class="equalizer" :class="[size]">
    <div class="bar" :class="[size, color]"></div>
    <div class="bar" :class="[size, color]"></div>
    <div class="bar" :class="[size, color]"></div>
  </div>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: 'md',
      required: false
    },
    color: {
      type: String, // red
      default: null,
      required: false
    }
  }
};
</script>
<style scoped src="@/assets/css/commonequalizer/commonequalizer.css"></style>
